'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _antd = require('antd');

var _reactDnd = require('react-dnd');

var _reactDndHtml5Backend = require('react-dnd-html5-backend');

var _reactDndHtml5Backend2 = _interopRequireDefault(_reactDndHtml5Backend);

var _immutabilityHelper = require('immutability-helper');

var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);

var _Dialog = require('material-ui/Dialog');

var _Dialog2 = _interopRequireDefault(_Dialog);

var _FlatButton = require('material-ui/FlatButton');

var _FlatButton2 = _interopRequireDefault(_FlatButton);

var _DeepLinkGenerator = require('../../components/common/DeepLinkGenerator');

var _DeepLinkGenerator2 = _interopRequireDefault(_DeepLinkGenerator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var dragingIndex = -1;

var BodyRow = function (_React$Component) {
  _inherits(BodyRow, _React$Component);

  function BodyRow() {
    _classCallCheck(this, BodyRow);

    return _possibleConstructorReturn(this, (BodyRow.__proto__ || Object.getPrototypeOf(BodyRow)).apply(this, arguments));
  }

  _createClass(BodyRow, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isOver = _props.isOver,
          connectDragSource = _props.connectDragSource,
          connectDropTarget = _props.connectDropTarget,
          moveRow = _props.moveRow,
          restProps = _objectWithoutProperties(_props, ['isOver', 'connectDragSource', 'connectDropTarget', 'moveRow']);

      var style = _extends({}, restProps.style, { cursor: 'move' });

      var className = restProps.className;

      if (isOver) {
        if (restProps.index > dragingIndex) {
          className += ' drop-over-downward';
        }
        if (restProps.index < dragingIndex) {
          className += ' drop-over-upward';
        }
      }

      return connectDragSource(connectDropTarget(_react2.default.createElement('tr', _extends({}, restProps, { className: className, style: style }))));
    }
  }]);

  return BodyRow;
}(_react2.default.Component);

var rowSource = {
  beginDrag: function beginDrag(props) {
    dragingIndex = props.index;
    return {
      index: props.index
    };
  }
};

var rowTarget = {
  drop: function drop(props, monitor) {
    var dragIndex = monitor.getItem().index;
    var hoverIndex = props.index;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Time to actually perform the action
    props.moveRow(dragIndex, hoverIndex);

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex;
  }
};

var DragableBodyRow = (0, _reactDnd.DropTarget)('row', rowTarget, function (connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  };
})((0, _reactDnd.DragSource)('row', rowSource, function (connect) {
  return {
    connectDragSource: connect.dragSource()
  };
})(BodyRow));

var DragSortingTable = function (_React$Component2) {
  _inherits(DragSortingTable, _React$Component2);

  function DragSortingTable(props) {
    _classCallCheck(this, DragSortingTable);

    var _this2 = _possibleConstructorReturn(this, (DragSortingTable.__proto__ || Object.getPrototypeOf(DragSortingTable)).call(this, props));

    _this2.moveRow = _this2.moveRow.bind(_this2);
    _this2.removeRow = _this2.removeRow.bind(_this2);
    _this2.generateDeepLink = _this2.generateDeepLink.bind(_this2);
    _this2.renderGenerateDeepLink = _this2.renderGenerateDeepLink.bind(_this2);

    _this2.state = {
      genericMaterialAreaIdDeeplink: null,
      modalOpened: false
    };
    return _this2;
  }

  _createClass(DragSortingTable, [{
    key: 'moveRow',
    value: function moveRow(dragIndex, hoverIndex) {
      var data = this.props.data;

      var dragRow = data[dragIndex];
      var onChange = this.props.onChange;


      onChange((0, _immutabilityHelper2.default)(this.props, {
        data: {
          $splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]]
        }
      }).data);
    }
  }, {
    key: 'renderGenerateDeepLink',
    value: function renderGenerateDeepLink() {
      var _this3 = this;

      var actions = [_react2.default.createElement(_FlatButton2.default, { label: 'Ok', primary: true, onClick: function onClick() {
          return _this3.setState({ genericMaterialAreaIdDeeplink: null, modalOpened: false });
        } })];

      var genericMaterialAreaIdDeeplink = this.state.genericMaterialAreaIdDeeplink;
      var _props2 = this.props,
          genericMaterialId = _props2.genericMaterialId,
          objectives = _props2.objectives;


      return _react2.default.createElement(
        _Dialog2.default,
        { title: 'Detalhes da Ordem', open: this.state.modalOpened, actions: actions, modal: true },
        _react2.default.createElement(_DeepLinkGenerator2.default, {
          objectives: objectives,
          isDisabled: false,
          generate: function generate(baseUrl, objectiveId) {
            return baseUrl + '?action=genericMaterialArea&objectiveId=' + objectiveId + '&genericMaterialId=' + genericMaterialId + '&genericMaterialAreaId=' + genericMaterialAreaIdDeeplink;
          }
        })
      );
    }
  }, {
    key: 'removeRow',
    value: function removeRow(row) {
      var _props3 = this.props,
          onChange = _props3.onChange,
          data = _props3.data;


      var rowIndex = data.findIndex(function (gMA) {
        return gMA.id === row.id;
      });

      var newData = [].concat(_toConsumableArray(data));
      newData.splice(rowIndex, 1);

      onChange(newData);
    }
  }, {
    key: 'generateDeepLink',
    value: function generateDeepLink(row) {
      this.setState({
        modalOpened: true,
        genericMaterialAreaIdDeeplink: row.id
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var data = this.props.data;

      var columns = [{
        title: 'Name',
        dataIndex: 'name',
        key: 'name'
      }, {
        title: 'Gerar Link',
        key: 'deeplink',
        fixed: 'right',
        width: 100,
        render: function render(row) {
          return _react2.default.createElement(
            'a',
            { onClick: function onClick() {
                return _this4.generateDeepLink(row);
              } },
            'Gerar Link'
          );
        }
      }, {
        title: 'Remover',
        key: 'remove',
        fixed: 'right',
        width: 100,
        render: function render(row) {
          return _react2.default.createElement(
            'a',
            { onClick: function onClick() {
                return _this4.removeRow(row);
              } },
            'Remover'
          );
        }
      }];

      return _react2.default.createElement(
        'div',
        { id: 'components-table-drag-sorting' },
        _react2.default.createElement(
          _reactDnd.DndProvider,
          { backend: _reactDndHtml5Backend2.default },
          _react2.default.createElement(_antd.Table, {
            rowKey: function rowKey(row) {
              return row.id;
            },
            columns: columns,
            dataSource: data,
            components: { body: { row: DragableBodyRow } },
            onRow: function onRow(record, index) {
              return {
                index: index,
                moveRow: _this4.moveRow
              };
            }
          })
        ),
        this.renderGenerateDeepLink()
      );
    }
  }]);

  return DragSortingTable;
}(_react2.default.Component);

exports.default = DragSortingTable;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/components/genericMaterialAreas/DragableGenericMaterialAreaTable.js
// module id = 2586
// module chunks = 0